module.exports = __webpack_public_path__ + "static/media/t5.dc3e55c4.png";